export interface EnemyTypeConfig {
  type: 'melee' | 'tank' | 'swarmer';
  speed: number;    // pixels per second
  hp: number;
  color: number;
  size: number;     // collision radius in pixels
  xpValue: number;
  damage: number;   // HP damage dealt to player per hit
}

// Base configs — these are the canonical stat values used for testing via page.evaluate
export const ENEMY_TYPES: Record<string, EnemyTypeConfig> = {
  melee: {
    type: 'melee',
    speed: 80,
    hp: 50,
    color: 0xff4444,
    size: 12,
    xpValue: 10,
    damage: 10,
  },
  tank: {
    type: 'tank',
    speed: 35,   // 43.75% of melee speed — satisfies ≤50% requirement
    hp: 175,     // 3.5× melee HP — satisfies ≥3× requirement
    color: 0xff8800,
    size: 20,
    xpValue: 35,
    damage: 20,
  },
  swarmer: {
    type: 'swarmer',
    speed: 130,
    hp: 20,      // 40% of melee HP — satisfies ≤50% requirement
    color: 0xdd44ff,
    size: 7,
    xpValue: 5,
    damage: 5,
  },
};
